import { gql } from '@apollo/client';

const changeDateRequestFragment = gql`
  fragment ChangeDateRequestFields on AppraiserEventChangeDateRequest {
    Id
    Status
    StartDate
    EndDate
    SubmitComment
    DeclineComment
    FDAReviewerName
  }
`;

export default changeDateRequestFragment;
